import {
  useQuery,
  QueryResult,
  QueryFunctionOptions,
  WatchQueryFetchPolicy,
} from '@apollo/client';
// Api
import { GET_INFLUENCER_CATEGORIES } from 'api/influencer-categories/queries';
// Types
import { GetInfluencerCategories } from 'api/influencer-categories/types/GetInfluencerCategories';

type UseGetInfluencerCategoriesOptions = QueryFunctionOptions<GetInfluencerCategories> & {
  fetchPolicy?: WatchQueryFetchPolicy;
};

export const useGetInfluencerCategories = (
  options?: UseGetInfluencerCategoriesOptions
): QueryResult<GetInfluencerCategories> => {
  return useQuery<GetInfluencerCategories>(GET_INFLUENCER_CATEGORIES, options);
};
